import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../service/AppComponent.class';
import { MortgageService } from '../mortgage.service';
import { PersonalInfo, PersonalInfoForm, QuestionsForm } from '../../../dialer/model/model.mortgage';
import { environment } from '../../../../environments/environment';
import { Theme } from '../../service/AutoTheme';
import { MatDialog, MatDialogRef } from '@angular/material';
import { SearchInsuranceComponent } from '../search-insurance/search-insurance.component';


@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent extends AppComponentClass<any, any> {

  private __data = new BehaviorSubject<PersonalInfo>(null);
  public solution = this.__data.asObservable();

  private __qsdata = new BehaviorSubject<QuestionsForm>(null);
  public qssolution = this.__qsdata.asObservable();
  public form: FormGroup;
  public formquestion: FormGroup;
  public crmlbl: any;
  public salesowner = sessionStorage.getItem("salesowner") || "NONE";
  currCamp: string;
  public crmtitle: string;
  public crmsubtitle1: string;
  public crmsubtitle2: string;
  public crmsubtitle3: string;
  public crmsubtitle4: string;
  public leadid = sessionStorage.getItem("leadID")
  // dialogRef: MatDialogRef<any>;
  show: boolean = true;
  show1: boolean = true;
  // fa fa-caret-down
  icon = "fa fa-caret-up"
  icon1 = "fa fa-caret-down"
  crldata: any;

  pageEmployes: any;
  crmname: any
  currcampflag: string;
  cdata1: QuestionsForm;

  @Input() data__1: any
  leads: any;


  constructor(public dialog: MatDialog, public edata: MortgageService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, protected theme: Theme) {
    super(edata, router, fb, msg);
    this.currCamp = sessionStorage.getItem("currcampaign");
    this.currcampflag = sessionStorage.getItem("currcampflag");
  }

  id_dialer: any = 0

  @Input() set personaldata(v: PersonalInfo) {
    this.debug_log("Setting current data");
    this.__data.next(v);
    console.log("personaldata", this.__data);

  }
  @Input() set compdata(v: QuestionsForm) {
    this.debug_log("Setting current data");
    this.__qsdata.next(v);
    console.log("compdata", this.__qsdata);

  }

  @Input('cdkTextareaAutosize')
  get enabled(): boolean { return this.enabled; }

  ngOnInit() {
    this.id_dialer = this.currcampflag
    console.log("data__1::", this.data__1)

    let crmlbldata = JSON.parse(sessionStorage.getItem("crmlabel"));
    let crmdata = this.crmlbl = JSON.parse(crmlbldata[0].crm_mgt);
    console.log(crmdata)
    this.crmname = crmdata[0].category;
    this.crmlbl = JSON.parse(crmlbldata[0].crm_mgt);
    let shift = this.crmlbl.shift()
    console.log(this.crmlbl)


    if (this.currcampflag == '1') {
      this.qssolution.subscribe(res => {
        console.log(res)
        if (res == null) {
          this.cdata1 = new QuestionsForm(null);
          this.formquestion = this.cdata1.makeform(this.fb);
        }
        else {
          this.cdata1 = new QuestionsForm(res);
          this.formquestion = this.cdata1.makeform(this.fb);
          sessionStorage.setItem("questions", JSON.stringify(this.cdata1));
        }
      })
    }
    else {
      this.solution.subscribe(res => {
        console.log(res);
        if (res == null) {
          this.cdata = new PersonalInfoForm(null);
          this.form = this.cdata.makeform(this.fb);
        }
        else {
          this.cdata = new PersonalInfoForm(res);
          this.form = this.cdata.makeform(this.fb);
          this.salesowner = sessionStorage.getItem("salesowner")
        }
      });
    }

  }

  warning() {
    if (this.cdata.birth_date != this.form.get("birth_date").value)
      this.cdata.birth_date = this.form.get("birth_date").value;
    if (this.cdata.spouse_birth_date != this.form.get("spouse_birth_date").value)
      this.cdata.spouse_birth_date = this.form.get("spouse_birth_date").value;
    if (this.cdata.age != this.form.get("age").value)
      this.cdata.age = this.form.get("age").value;
    if (this.cdata.spouse_age != this.form.get("spouse_age").value)
      this.cdata.spouse_age = this.form.get("spouse_age").value;
    if (this.cdata.occupation != this.form.get("occupation").value)
      this.cdata.occupation = this.form.get("occupation").value;
    if (this.cdata.spouse_occupation != this.form.get("spouse_occupation").value)
      this.cdata.spouse_occupation = this.form.get("spouse_occupation").value;
    if (this.cdata.height != this.form.get("height").value)
      this.cdata.height = this.form.get("height").value;
    if (this.cdata.spouse_height != this.form.get("spouse_height").value)
      this.cdata.spouse_height = this.form.get("spouse_height").value;
    if (this.cdata.weight != this.form.get("weight").value)
      this.cdata.weight = this.form.get("weight").value;
    if (this.cdata.spouse_weight != this.form.get("spouse_weight").value)
      this.cdata.spouse_weight = this.form.get("spouse_weight").value;
    if (this.cdata.smoker != this.form.get("smoker").value)
      this.cdata.smoker = this.form.get("smoker").value;
    if (this.cdata.spouse_smoker != this.form.get("spouse_smoker").value)
      this.cdata.spouse_smoker = this.form.get("spouse_smoker").value;
    if (this.cdata.health_issue != this.form.get("health_issue").value)
      this.cdata.health_issue = this.form.get("health_issue").value;
    if (this.cdata.spouse_health_issue != this.form.get("spouse_health_issue").value)
      this.cdata.spouse_health_issue = this.form.get("spouse_health_issue").value;
    if (this.cdata.lender != this.form.get("lender").value)
      this.cdata.lender = this.form.get("lender").value;
    if (this.cdata.beneficiary != this.form.get("beneficiary").value)
      this.cdata.beneficiary = this.form.get("beneficiary").value;
    if (this.cdata.mortgage_amount != this.form.get("mortgage_amount").value)
      this.cdata.mortgage_amount = this.form.get("mortgage_amount").value;
    if (this.cdata.lead_level != this.form.get("lead_level").value)
      this.cdata.lead_level = this.form.get("lead_level").value;
    if (this.cdata.purchase_refi != this.form.get("purchase_refi").value)
      this.cdata.purchase_refi = this.form.get("purchase_refi").value;
    if (this.cdata.assign_date != this.form.get("assign_date").value)
      this.cdata.assign_date = this.form.get("assign_date").value;
    if (this.cdata.home_value != this.form.get("home_value").value)
      this.cdata.home_value = this.form.get("home_value").value;
    if (this.cdata.status != this.form.get("status").value)
      this.cdata.status = this.form.get("status").value;
    if (this.cdata.mortgage_term != this.form.get("mortgage_term").value)
      this.cdata.mortgage_term = this.form.get("mortgage_term").value;
    if (this.cdata.referrer != this.form.get("referrer").value)
      this.cdata.referrer = this.form.get("referrer").value;
    if (this.cdata.monthly_mortage_payment != this.form.get("monthly_mortage_payment").value)
      this.cdata.monthly_mortage_payment = this.form.get("monthly_mortage_payment").value;
    if (this.cdata.reason != this.form.get("reason").value)
      this.cdata.reason = this.form.get("reason").value;
    if (this.cdata.field_1 != this.form.get("field_1").value)
      this.cdata.field_1 = this.form.get("field_1").value;
    if (this.cdata.field_2 != this.form.get("field_2").value)
      this.cdata.field_2 = this.form.get("field_2").value;
    if (this.cdata.field_3 != this.form.get("field_3").value)
      this.cdata.field_3 = this.form.get("field_3").value;
    if (this.cdata.field_4 != this.form.get("field_4").value)
      this.cdata.field_4 = this.form.get("field_4").value;
    if (this.cdata.field_5 != this.form.get("field_5").value)
      this.cdata.field_5 = this.form.get("field_5").value;
    if (this.cdata.field_6 != this.form.get("field_6").value)
      this.cdata.field_6 = this.form.get("field_6").value;
    if (this.cdata.field_7 != this.form.get("field_7").value)
      this.cdata.field_7 = this.form.get("field_7").value;
    if (this.cdata.field_8 != this.form.get("field_8").value)
      this.cdata.field_8 = this.form.get("field_8").value;
    if (this.cdata.field_9 != this.form.get("field_9").value)
      this.cdata.field_9 = this.form.get("field_9").value;
    if (this.cdata.field_10 != this.form.get("field_10").value)
      this.cdata.field_10 = this.form.get("field_10").value;
    if (this.cdata.field_11 != this.form.get("field_11").value)
      this.cdata.field_11 = this.form.get("field_11").value;
    if (this.cdata.field_12 != this.form.get("field_12").value)
      this.cdata.field_12 = this.form.get("field_12").value;
    if (this.cdata.field_13 != this.form.get("field_13").value)
      this.cdata.field_13 = this.form.get("field_13").value;
    if (this.cdata.field_14 != this.form.get("field_14").value)
      this.cdata.field_14 = this.form.get("field_14").value;
    if (this.cdata.field_15 != this.form.get("field_15").value)
      this.cdata.field_15 = this.form.get("field_15").value;
    if (this.cdata.field_16 != this.form.get("field_16").value)
      this.cdata.field_16 = this.form.get("field_16").value;
    if (this.cdata.field_17 != this.form.get("field_17").value)
      this.cdata.field_17 = this.form.get("field_17").value;
    if (this.cdata.field_18 != this.form.get("field_18").value)
      this.cdata.field_18 = this.form.get("field_18").value;
    if (this.cdata.field_19 != this.form.get("field_19").value)
      this.cdata.field_19 = this.form.get("field_19").value;
    if (this.cdata.field_20 != this.form.get("field_20").value)
      this.cdata.field_20 = this.form.get("field_20").value;
    if (this.cdata.field_21 != this.form.get("field_21").value)
      this.cdata.field_21 = this.form.get("field_21").value;
    if (this.cdata.field_22 != this.form.get("field_22").value)
      this.cdata.field_22 = this.form.get("field_22").value;
    if (this.cdata.field_23 != this.form.get("field_23").value)
      this.cdata.field_23 = this.form.get("field_23").value;
    if (this.cdata.field_24 != this.form.get("field_24").value)
      this.cdata.field_24 = this.form.get("field_24").value;
    if (this.cdata.field_15 != this.form.get("field_15").value)
      this.cdata.field_15 = this.form.get("field_15").value;
    if (this.cdata.field_26 != this.form.get("field_26").value)
      this.cdata.field_26 = this.form.get("field_26").value;
    if (this.cdata.field_27 != this.form.get("field_27").value)
      this.cdata.field_27 = this.form.get("field_27").value;
    if (this.cdata.field_28 != this.form.get("field_28").value)
      this.cdata.field_28 = this.form.get("field_28").value;
    if (this.cdata.field_29 != this.form.get("field_29").value)
      this.cdata.field_29 = this.form.get("field_29").value;
    if (this.cdata.field_30 != this.form.get("field_30").value)
      this.cdata.field_30 = this.form.get("field_30").value;
    if (this.cdata.field_31 != this.form.get("field_31").value)
      this.cdata.field_31 = this.form.get("field_31").value;
    if (this.cdata.field_32 != this.form.get("field_32").value)
      this.cdata.field_32 = this.form.get("field_32").value;
    if (this.cdata.field_33 != this.form.get("field_33").value)
      this.cdata.field_33 = this.form.get("field_33").value;
    if (this.cdata.field_34 != this.form.get("field_34").value)
      this.cdata.field_34 = this.form.get("field_34").value;
    if (this.cdata.field_35 != this.form.get("field_35").value)
      this.cdata.field_35 = this.form.get("field_35").value;
    if (this.cdata.field_36 != this.form.get("field_36").value)
      this.cdata.field_36 = this.form.get("field_36").value;
    if (this.cdata.field_37 != this.form.get("field_37").value)
      this.cdata.field_37 = this.form.get("field_37").value;
    if (this.cdata.field_38 != this.form.get("field_38").value)
      this.cdata.field_38 = this.form.get("field_38").value;
    if (this.cdata.field_39 != this.form.get("field_39").value)
      this.cdata.field_39 = this.form.get("field_39").value;
    if (this.cdata.field_40 != this.form.get("field_40").value)
      this.cdata.field_40 = this.form.get("field_40").value;
    if (this.cdata.field_41 != this.form.get("field_41").value)
      this.cdata.field_41 = this.form.get("field_41").value;
    if (this.cdata.field_42 != this.form.get("field_42").value)
      this.cdata.field_42 = this.form.get("field_42").value;
    if (this.cdata.field_43 != this.form.get("field_43").value)
      this.cdata.field_43 = this.form.get("field_43").value;
    if (this.cdata.field_44 != this.form.get("field_44").value)
      this.cdata.field_44 = this.form.get("field_44").value;
    if (this.cdata.field_45 != this.form.get("field_45").value)
      this.cdata.field_45 = this.form.get("field_45").value;
    if (this.cdata.field_46 != this.form.get("field_46").value)
      this.cdata.field_46 = this.form.get("field_46").value;
    if (this.cdata.field_47 != this.form.get("field_47").value)
      this.cdata.field_47 = this.form.get("field_47").value;
    if (this.cdata.field_48 != this.form.get("field_48").value)
      this.cdata.field_48 = this.form.get("field_48").value;
    if (this.cdata.field_49 != this.form.get("field_49").value)
      this.cdata.field_49 = this.form.get("field_49").value;
    if (this.cdata.field_50 != this.form.get("field_50").value)
      this.cdata.field_50 = this.form.get("field_50").value;

    if (this.currcampflag == '1') {
      if (this.cdata1.mostlike != this.formquestion.get("mostlike").value)
        this.cdata1.mostlike = this.formquestion.get("mostlike").value;
    }

  }

  changeEvnt(key: string) {
    console.log(key);
    console.log("currcampflag ::", this.currcampflag);
    if (this.currcampflag == '0') {
      if (key == 'lead_source')
        this.cdata.lead_source = this.form.get("lead_source").value;
      if (key == 'birth_date')
        this.cdata.birth_date = this.form.get("birth_date").value;
      if (key == 'spouse_birth_date')
        this.cdata.spouse_birth_date = this.form.get("spouse_birth_date").value;
      if (key == 'age')
        this.cdata.age = this.form.get("age").value;
      if (key == 'spouse_age')
        this.cdata.spouse_age = this.form.get("spouse_age").value;
      if (key == 'occupation')
        this.cdata.occupation = this.form.get("occupation").value;
      if (key == 'spouse_occupation')
        this.cdata.spouse_occupation = this.form.get("spouse_occupation").value;
      if (key == 'height')
        this.cdata.height = this.form.get("height").value;
      if (key == 'spouse_height')
        this.cdata.spouse_height = this.form.get("spouse_height").value;
      if (key == 'weight')
        this.cdata.weight = this.form.get("weight").value;
      if (key == 'spouse_weight')
        this.cdata.spouse_weight = this.form.get("spouse_weight").value;
      if (key == 'smoker')
        this.cdata.smoker = this.form.get("smoker").value;
      if (key == 'spouse_smoker')
        this.cdata.spouse_smoker = this.form.get("spouse_smoker").value;
      if (key == 'health_issue')
        this.cdata.health_issue = this.form.get("health_issue").value;
      if (key == 'spouse_health_issue')
        this.cdata.spouse_health_issue = this.form.get("spouse_health_issue").value;
      if (key == 'lender')
        this.cdata.lender = this.form.get("lender").value;
      if (key == 'beneficiary')
        this.cdata.beneficiary = this.form.get("beneficiary").value;
      if (key == 'mortgage_amount')
        this.cdata.mortgage_amount = this.form.get("mortgage_amount").value;
      if (key == 'lead_level')
        this.cdata.lead_level = this.form.get("lead_level").value;
      if (key == 'purchase_refi')
        this.cdata.purchase_refi = this.form.get("purchase_refi").value;
      if (key == 'assign_date')
        this.cdata.assign_date = this.form.get("assign_date").value;
      if (key == 'home_value')
        this.cdata.home_value = this.form.get("home_value").value;
      if (key == 'status')
        this.cdata.status = this.form.get("status").value;
      if (key == 'mortgage_term')
        this.cdata.mortgage_term = this.form.get("mortgage_term").value;
      if (key == 'referrer')
        this.cdata.referrer = this.form.get("referrer").value;
      if (key == 'monthly_mortage_payment')
        this.cdata.monthly_mortage_payment = this.form.get("monthly_mortage_payment").value;
      if (key == 'reason')
        this.cdata.reason = this.form.get("reason").value;
      if (key == 'field_1')
        this.cdata.field_1 = this.form.get("field_1").value;
      if (key == 'field_2')
        this.cdata.field_2 = this.form.get("field_2").value;
      if (key == 'field_3')
        this.cdata.field_3 = this.form.get("field_3").value;
      if (key == 'field_4')
        this.cdata.field_4 = this.form.get("field_4").value;
      if (key == 'field_5')
        this.cdata.field_5 = this.form.get("field_5").value;
      if (key == 'field_6')
        this.cdata.field_6 = this.form.get("field_6").value;
      if (key == 'field_7')
        this.cdata.field_7 = this.form.get("field_7").value;
      if (key == 'field_8')
        this.cdata.field_8 = this.form.get("field_8").value;
      if (key == 'field_9')
        this.cdata.field_9 = this.form.get("field_9").value;
      if (key == 'field_10')
        this.cdata.field_10 = this.form.get("field_10").value;
      if (key == 'field_11')
        this.cdata.field_11 = this.form.get("field_11").value;
      if (key == 'field_12')
        this.cdata.field_12 = this.form.get("field_12").value;
      if (key == 'field_13')
        this.cdata.field_13 = this.form.get("field_13").value;
      if (key == 'field_14')
        this.cdata.field_14 = this.form.get("field_14").value;
      if (key == 'field_15')
        this.cdata.field_15 = this.form.get("field_15").value;
      if (key == 'field_16')
        this.cdata.field_16 = this.form.get("field_16").value;
      if (key == 'field_17')
        this.cdata.field_17 = this.form.get("field_17").value;
      if (key == 'field_18')
        this.cdata.field_18 = this.form.get("field_18").value;
      if (key == 'field_19')
        this.cdata.field_19 = this.form.get("field_19").value;
      if (key == 'field_20')
        this.cdata.field_20 = this.form.get("field_20").value;
      if (key == 'field_21')
        this.cdata.field_21 = this.form.get("field_21").value;
      if (key == 'field_22')
        this.cdata.field_22 = this.form.get("field_22").value;
      if (key == 'field_23')
        this.cdata.field_23 = this.form.get("field_23").value;
      if (key == 'field_24')
        this.cdata.field_24 = this.form.get("field_24").value;
      if (key == 'field_25')
        this.cdata.field_25 = this.form.get("field_25").value;
      if (key == 'field_26')
        this.cdata.field_26 = this.form.get("field_26").value;
      if (key == 'field_27')
        this.cdata.field_27 = this.form.get("field_27").value;
      if (key == 'field_28')
        this.cdata.field_28 = this.form.get("field_28").value;
      if (key == 'field_29')
        this.cdata.field_29 = this.form.get("field_29").value;
      if (key == 'field_30')
        this.cdata.field_30 = this.form.get("field_30").value;
      if (key == 'field_31')
        this.cdata.field_31 = this.form.get("field_31").value;
      if (key == 'field_32')
        this.cdata.field_32 = this.form.get("field_32").value;
      if (key == 'field_33')
        this.cdata.field_33 = this.form.get("field_33").value;
      if (key == 'field_34')
        this.cdata.field_34 = this.form.get("field_34").value;
      if (key == 'field_35')
        this.cdata.field_35 = this.form.get("field_35").value;
      if (key == 'field_36')
        this.cdata.field_36 = this.form.get("field_36").value;
      if (key == 'field_37')
        this.cdata.field_37 = this.form.get("field_37").value;
      if (key == 'field_38')
        this.cdata.field_38 = this.form.get("field_38").value;
      if (key == 'field_39')
        this.cdata.field_39 = this.form.get("field_39").value;
      if (key == 'field_40')
        this.cdata.field_40 = this.form.get("field_40").value;
      if (key == 'field_40')
        this.cdata.field_40 = this.form.get("field_40").value;
      if (key == 'field_42')
        this.cdata.field_42 = this.form.get("field_42").value;
      if (key == 'field_43')
        this.cdata.field_43 = this.form.get("field_43").value;
      if (key == 'field_44')
        this.cdata.field_44 = this.form.get("field_44").value;
      if (key == 'field_45')
        this.cdata.field_45 = this.form.get("field_45").value;
      if (key == 'field_46')
        this.cdata.field_46 = this.form.get("field_46").value;
      if (key == 'field_47')
        this.cdata.field_47 = this.form.get("field_47").value;
      if (key == 'field_48')
        this.cdata.field_48 = this.form.get("field_48").value;
      if (key == 'field_49')
        this.cdata.field_49 = this.form.get("field_49").value;
      if (key == 'field_50')
        this.cdata.field_50 = this.form.get("field_50").value;

      sessionStorage.setItem("personaldata", JSON.stringify(this.cdata));
      console.log(sessionStorage.getItem("personaldata"));

      this.theme.Getautosavedata(sessionStorage.getItem("personaldata"))
    }
    if (this.currcampflag == '1') {
      if (key == 'uscitizon')
        this.cdata1.uscitizon = this.formquestion.get("uscitizon").value;
      if (key == 'worktimezone')
        this.cdata1.worktimezone = this.formquestion.get("worktimezone").value;
      if (key == 'isfelony')
        this.cdata1.isfelony = this.formquestion.get("isfelony").value;
      if (key == 'previousemployment')
        this.cdata1.previousemployment = this.formquestion.get("previousemployment").value;
      if (key == 'mostlike')
        this.cdata1.mostlike = this.formquestion.get("mostlike").value;
      if (key == 'leastlike')
        this.cdata1.leastlike = this.formquestion.get("leastlike").value;
      if (key == 'income')
        this.cdata1.income = this.formquestion.get("income").value;
      if (key == 'corporateview')
        this.cdata1.corporateview = this.formquestion.get("corporateview").value;
      if (key == 'agenttype')
        this.cdata1.agenttype = this.formquestion.get("agenttype").value;
      if (key == 'agentanswer')
        this.cdata1.agentanswer = this.formquestion.get("agentanswer").value;
      if (key == 'bestyou')
        this.cdata1.bestyou = this.formquestion.get("bestyou").value;
      if (key == 'courseaction')
        this.cdata1.courseaction = this.formquestion.get("courseaction").value;
      if (key == 'havelifeinsurance')
        this.cdata1.havelifeinsurance = this.formquestion.get("havelifeinsurance").value;
      if (key == 'feelgood')
        this.cdata1.feelgood = this.formquestion.get("feelgood").value;
      if (key == 'knowcompany')
        this.cdata1.knowcompany = this.formquestion.get("knowcompany").value;

      sessionStorage.setItem("questions", JSON.stringify(this.cdata1));
      console.log(sessionStorage.getItem("questions"));
    }

    this.theme.Getautosavedata(sessionStorage.getItem("questions"))

    let current = parseInt(sessionStorage.getItem("current_lead"));
    let search_lead = parseInt(sessionStorage.getItem("search_lead"));
    if (search_lead != 0) {
      current = search_lead;
    }
    console.log("current_lead: " + current);

  }

  onSubmit() {
    console.log("Saveform", this.cdata);
    if (this.cdata.saveForm(this.form))
      super.onSubmit();
  }

  arrows() {
    this.show = !this.show;
    if (this.show) {
      this.icon = "fa fa-caret-up";
    }
    else {
      this.icon = "fa fa-caret-down"
    }

  }

  arrows1() {
    this.show1 = !this.show1;
    if (this.show1) {
      this.icon1 = "fa fa-caret-up";
    }
    else {
      this.icon1 = "fa fa-caret-down"
    }

  }

  insuranceSearch(): void {

    let data = { id_lead: JSON.parse(sessionStorage.getItem('leadID')), edit: JSON.parse(sessionStorage.getItem('edit')), personaldata: JSON.parse(sessionStorage.getItem('personaldata')), id_script: JSON.parse(sessionStorage.getItem('currscript')), questions: JSON.parse(sessionStorage.getItem("questions")), comments: JSON.parse(sessionStorage.getItem('comment')).comments, objection: sessionStorage.getItem("objection_id"), id_dialer: this.id_dialer, currcampflag: this.currcampflag };
    let jsondata = JSON.stringify(data);
    jsondata = jsondata.replace(/"null"/g, '""');

    console.log("JsonData", jsondata)
    this.edata.leadUpdate(jsondata, parseInt(sessionStorage.getItem('leadID'))).subscribe(rs => {

      this.ISredirect();

    });

  }

  ISredirect() {
    this.edata.insuranceData(this.data__1).subscribe(res => {
      console.log("insuranceData", res);
    })
    let vm_session: any = sessionStorage.getItem("vm_session")
    console.log(environment.VM_ACCESS + "?vm_session=" + vm_session + "&leadid=" + sessionStorage.getItem("leadID"))
    if (sessionStorage.getItem("vm_session")) {
      window.open(environment.VM_ACCESS + "?vm_session=" + vm_session + "&leadid=" + sessionStorage.getItem("leadID"), "_blank")
    } else {
      alert("You must have VM account\nTo search the insurance!")
    }
  }

  searchInsurance() : void {
      const dialogRef = this.dialog.open(SearchInsuranceComponent);
      sessionStorage.removeItem("searchData");
      // sessionStorage.removeItem("buildData");


  };

}


